import { SubscriptionType } from '../enums/SubscriptionType'
import useSubscriptionsQuery from './useSubscriptionsQuery'

/**
 * Uses a suspense query under the hood
 */
export default function useSubscription(subscriptionType: SubscriptionType) {
  // Get it from this query rather than somewhere else, just because
  // this is used in a few places, so we can avoid extra requests
  const subscriptions = useSubscriptionsQuery().data

  return subscriptions.find(
    (subscription) => subscription.subscriptionType === subscriptionType,
  )
}
